var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !!_vm.title || !!_vm.subtitle
    ? _c("header", { class: _vm.bemBlock, style: _vm.cssCustomProps }, [
        !!_vm.subtitle
          ? _c("p", { class: _vm.bemElement("subtitle") }, [
              _vm._v("\n    " + _vm._s(_vm.subtitle) + "\n  ")
            ])
          : _vm._e(),
        _vm._v(" "),
        !!_vm.title
          ? _c("h2", { class: _vm.bemElement("title") }, [
              _c("span", [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")])
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }